import React, {useState, useRef, useEffect} from 'react';
import {INSTALLATION_PAGES} from "../JobOrderInstallationPage";
import Card from "../../components/Card";
import axios from "axios";
import {toast} from "react-toastify";
import {format, parse} from "date-fns";
import {DATE_FORMATS} from "../../constants/DateFormats";
import Products from "./components/Products";

const JobOrderInstallationShowPage = (props) => {
    const {
        jobId           = null,
        orderId         = null,
        installationId  = null,
        onChangePage    = (INDEX, installation) => {}
    } = props;

    const [installation, setInstallation] = useState(null);

    useEffect(() => {
        if (!!installationId) {
            load();
        }
    }, [installationId]);

    const load = () => {
        axios.get(route('web-api.job.order.installation.config', {job: jobId, order: orderId, installation_id: installationId}).toString())
            .then((response) => {
                if (!!response && !!response.data) {

                    if (!!response.data.installation) {
                        setInstallation(response.data.installation);
                    }
                }
            })
            .catch((error) => {
                console.log(error);
                toast.error(<div>{"An error occurred"}</div>);
            });
    }

    const reset = () => {
        setInstallation(null);
    }

    const handleClickBack = (event) => {
        event.preventDefault();
        reset();
        onChangePage(INSTALLATION_PAGES.INDEX, null);
    }

    const renderDate = (dateString) => {
        return format(parse(dateString, DATE_FORMATS.DB_DATE, new Date()), DATE_FORMATS.DATE);
    }

    const renderInstallationImages = () => {
        return (
            <div className={"image-row"}>
                {!!installation && !!installation.images && installation.images.length > 0 && installation.images.map((image) => {
                    let content = null;
                    if (image.type === "image") {
                        content = (
                            <img src={image.url} alt={image.name} title={image.name} className={"image"} />
                        );
                    } else {
                        content = (
                            <div className={"placeholder"} title={image.name}>Click To Open</div>
                        );
                    }

                    return (
                        <a href={image.url} target={"_blank"} className={"d-block mr-2 mb-2"}>
                            {content}
                        </a>
                    );
                })}
            </div>
        )
    }

    return (
        <React.Fragment>
            <Card
                title={"Installation Details"}
                classes={"mh-100 border-0"}
                controls={can('viewAny', 'installation') ? (
                    <button
                        onClick={(event) => handleClickBack(event)}
                        className={"btn font-weight-bold btn-outline-eh-off-black px-4 m-0"}
                    >
                        <i className={"fa fa-chevron-left mr-2"} />
                        <span>{"Back"}</span>
                    </button>
                ) : null}
            >
                <div className="row m-0 mb-4 p-0 bg-eh-lightest-grey border border-eh-mid-grey rounded">
                    <div className="col-12 m-0 p-4">
                        <div className="row m-0 p-0">
                            <div className={"col-12 col-md-6 col-lg-4 m-0 p-0 pr-md-2"}>
                                <p className="mb-0 text-eh-off-black"><strong>Installation Start</strong></p>
                                <p className="text-eh-off-black">{!!installation && !!installation.start_at ? renderDate(installation.start_at) : "-"}</p>
                            </div>
                            <div className={"col-12 col-md-6 col-lg-4 m-0 p-0 pl-md-2 px-lg-2"}>
                                <p className="mb-0 text-eh-off-black"><strong>Installation End</strong></p>
                                <p className="text-eh-off-black">{!!installation && !!installation.end_at ? renderDate(installation.end_at) : "-"}</p>
                            </div>
                            <div className={"col-12 col-md-6 col-lg-4 m-0 p-0 pr-md-2 pl-lg-0 pr-lg-2"}>
                                <p className="mb-0 text-eh-off-black"><strong>Installation Created</strong></p>
                                <p className="text-eh-off-black">{!!installation && !!installation.created_at ? renderDate(installation.created_at) : "-"}</p>
                            </div>
                        </div>
                        <div className="row m-0 p-0">
                            <div className={"col-12 col-md-6 col-lg-4 m-0 p-0 pr-md-2"}>
                                <p className="mb-0 text-eh-off-black"><strong>Status</strong></p>
                                <p className="text-eh-off-black">{!!installation && !!installation.status ? installation.status : "-"}</p>
                            </div>
                            <div className={"col-12 col-md-6 col-lg-8 m-0 p-0 pl-md-2"}>
                                <p className="mb-0 text-eh-off-black"><strong>Installers</strong></p>
                                <p className="text-eh-off-black">{!!installation && !!installation.installers ? installation.installers : "-"}</p>
                            </div>
                        </div>
                        <div className="row m-0 p-0">
                            <div className="col-12 m-0 p-0">
                                <p className="mb-0 text-eh-off-black"><strong>Notes</strong></p>
                                <p className="text-eh-off-black">{!!installation && !!installation.notes ? installation.notes : "-"}</p>
                            </div>
                        </div>
                        <div className="row m-0 p-0">
                            <div className="col-12 m-0 p-0">
                                <p className={!!installation && !!installation.images && (installation.images.length > 0) ? "mb-2 text-eh-off-black" : "mb-0 text-eh-off-black"}><strong>Installer Photos</strong></p>
                                <p className="text-eh-off-black">{!!installation && !!installation.images && (installation.images.length > 0) ? renderInstallationImages() : "-"}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row m-0 p-0">
                    <div className="col-12 m-0 p-0">
                        <Products products={!!installation ? installation.products : []} />
                    </div>
                </div>
            </Card>
        </React.Fragment>
    );
}

export default JobOrderInstallationShowPage;
